import MyCreateZongcuRoute from './components/my-create-zongcu/route-config';
import MyJoinZongcuRoute from './components/my-join-zongcu/route-config';
import MyManageZongcuRoute from './components/my-manage-zongcu/route-config';

export default [
  {
    title: '我参与的活动',
    path: '/myJoin',
    menus: MyJoinZongcuRoute,
  },
  {
    title: '我创建的活动',
    path: '/myCreate',
    menus: MyCreateZongcuRoute,
  },
  {
    title: '我管理的活动',
    path: '/myManage',
    menus: MyManageZongcuRoute,
  },
];
